import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../../../core/services/config.service';
import { OutputService } from '../../services/output.service';
import { OkDialogService } from '../../services/ok-dialog.service';


@Component({
  templateUrl: './export-xml-page.html',
  styleUrls: ['./export-xml-page.scss'],
})

export class ExportXmlPageComponent {

  showLoader = false;
  letters = [
    'א',
    'ב',
    'ג',
    'ד',
    'ה',
    'ו',
    'ז',
    'ח',
    'ט',
    'י',
    'כ',
    'ל',
    'מ',
    'נ',
    'ס',
    'ע',
    'פ',
    'צ',
    'ק',
    'ר',
    'ש',
    'ת',
  ];

  constructor(
    private router:Router,
    private configService:ConfigService,
    private outputService:OutputService,
    private okDialogService:OkDialogService,
  ) {
  }


  ngOnInit() {


  }


  navTo(dest) {
    this.router.navigate([dest]);
  }


  exportSection(letter) {

    this.showLoader = true;
    console.log('exporting letter', letter);

    setTimeout(() => {
      Promise.resolve()
        .then(() => this.generateSection(letter))
        .then(() => {

          setTimeout(() => {
            this.showLoader = false;
          }, 0);


          this.okDialogService.show(`Section ${letter} was sent successfully.<br><br>Check your email.`);
          // window.open(`${this.configService.organizationConfig.apiEndpoint}/export/${letter}`);

        });
    }, 1000);
  }


  generateSection(letter) {
    return Promise.resolve()
      .then(() => this.outputService.create({
        mode: 'export-xml',
        letter: letter,
      }))
      .then(result => {

        if (result.success) {
          return;
        } else {
          throw new Error('There was a problem');
        }

      });
  }

}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/export-xml-page/export-xml-page.ts